import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

export function LegalLayout({
  eyebrow,
  title,
  updated,
  children,
}: {
  eyebrow: string;
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="flex items-center justify-between px-8 py-6 lg:px-16">
        <Link to="/" className="block">
          <p className="tracking-wide-luxury text-accent">The Hospitality</p>
<p className="font-display text-lg">Reserve</p>
        </Link>
        <Link
          to="/"
          className="text-xs tracking-wide-luxury text-muted-foreground hover:text-accent transition-colors"
        >
          Return Home
        </Link>
      </header>

      <main className="mx-auto max-w-3xl px-8 pb-24 pt-12 lg:px-0">
        <p className="tracking-wide-luxury text-accent">{eyebrow}</p>
        <span className="gold-divider mt-6" />
        <h1 className="mt-6 font-display text-4xl md:text-5xl">{title}</h1>
        <p className="mt-4 text-xs tracking-wide-luxury text-muted-foreground/70">
          Last updated: {updated}
        </p>

        <div className="legal-prose mt-12 text-sm leading-relaxed text-muted-foreground">
          {children}
        </div>

        <style>{`
          .legal-prose > * + * { margin-top: 1rem; }
          .legal-prose h2,
          .legal-prose h3 {
            font-family: var(--font-display);
            color: var(--foreground);
            margin-top: 2.5rem;
            margin-bottom: 0.5rem;
          }
          .legal-prose h2 { font-size: 1.5rem; }
          .legal-prose h3 { font-size: 1.15rem; font-weight: 500; }
          .legal-prose ul { list-style: disc; padding-left: 1.25rem; }
          .legal-prose ul li + li { margin-top: 0.5rem; }
          .legal-prose a { color: var(--accent); text-decoration: underline; }
          .legal-prose strong { color: var(--foreground); }
          .legal-prose code {
            background: var(--muted);
            padding: 0 0.25rem;
            border-radius: 2px;
            font-size: 0.85em;
          }
        `}</style>

        <div className="mt-16 border-t border-border pt-8 text-xs text-muted-foreground/70">
          <p>
            The Hospitality Reserve operates as a neutral technology platform. We are
            not an employer, employment business, or employment agency within the
            meaning of the Employment Agencies Act 1973. Any engagement is
            strictly between the venue (client) and the bartender (independent
            contractor).
          </p>
        </div>
      </main>
    </div>
  );
}
